import React from 'react';
import { SnackbarProvider } from 'notistack';
import { ConfirmProvider } from 'material-ui-confirm';
import ThemeProvider from './theme';
import ScrollToTop from './components/ScrollToTop';
import { BaseOptionChartStyle } from './components/chart/BaseOptionChart';
import { GlobalThemeProvider } from './contexts/ThemeContext';
import { IdleProvider } from './contexts/IdleContext';
import Router from './routes';

import './App.scss';

export default function App() {
  return (
    <GlobalThemeProvider>
      <IdleProvider>
        <ThemeProvider>
          <SnackbarProvider
            maxSnack={3}
            autoHideDuration={3000}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
          >
            <ConfirmProvider>
              <ScrollToTop />
              <BaseOptionChartStyle />
              <Router />
            </ConfirmProvider>
          </SnackbarProvider>
        </ThemeProvider>
      </IdleProvider>
    </GlobalThemeProvider>
  );
}
